import { formatPrice } from "$store/sdk/format.ts";

interface Props {
  total: number;
  target: number;
  locale: string;
  currency: string;
}

function FreeShippingProgressBar({ target, total, currency, locale }: Props) {
  const remaining = target - total;
  const percent = Math.floor((total / target) * 100);

  return (
    <div class="h-16 bg-tw-neutral-500 flex shrink-0 justify-center items-center gap-2 relative lg:max-2xl:h-10">
      {remaining > 0
        ? (
          <span class="max-w-[13rem] text-white text-center z-10 lg:max-2xl:max-w-none lg:max-2xl:text-sm lg:max-2xl:leading-none">
            Não perca o frete{" "}
            <span class="text-lg font-extrabold leading-none lg:max-2xl:text-base lg:max-2xl:leading-none">
              GRÁTIS
            </span>{" "}
            faltam apenas{" "}
            <span class="text-lg font-extrabold leading-none lg:max-2xl:text-base lg:max-2xl:leading-none">
              {formatPrice(
                remaining,
                currency,
                locale,
              )}*
            </span>
          </span>
        )
        : (
          <span class="max-w-[16rem] text-white text-center z-10 lg:max-2xl:max-w-none lg:max-2xl:text-sm lg:max-2xl:leading-none">
            Parabéns! Você ganhou frete{" "}
            <span
              class={`text-lg leading-none font-extrabold uppercase lg:max-2xl:text-base lg:max-2xl:leading-none ${
                percent >= 100 ? "free-shipping-bar-label-pulse" : ""
              }`}
            >
              grátis
            </span>{" "}
            <span class="lg:max-2xl:text-xs lg:max-2xl:block">
              válido para todo o Brasil.
            </span>
          </span>
        )}

      <div
        class={`free-shipping-bar h-full overflow-hidden absolute top-0 left-0 z-0 ${
          percent >= 100 ? "free-shipping-bar--reached" : ""
        }`}
        style={{ width: `${percent > 100 ? 100 : percent}%` }}
      />
    </div>
  );
}

export default FreeShippingProgressBar;
